import Vue from "vue";
import Locked from "@/components/Locked.vue";

export default Vue.extend({
  components: { Locked },
  data: () => ({
    loading: false
  }),
  methods: {
    async openFile(filename: string, delay: number = 0) {
      this.loading = true;
      const toolname =
        this.$options.name!.charAt(0).toLowerCase() +
        this.$options.name!.slice(1);
      if (delay) await new Promise(__ => setTimeout(__, delay));
      const response = await this.axios.post("document_download", null, {
        params: {
          tool: this.$options.name,
          id: (this as any)[toolname]!.id.split("/")[2],
          filename: filename
        },
        responseType: "arraybuffer",
        headers: {
          Accept: "application/pdf"
        }
      });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      this.loading = false;
    }
  }
});
